module.exports = __webpack_public_path__ + "static/media/ye-qr.f73c110b.jpg";